import React from "react";
import { Link } from "react-router-dom";

const Ordina = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-sage-light to-beige-light">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('/images/ordina-hero.jpg')`,
          backgroundPosition: '50% 50%'}}
        />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-6xl font-title font-bold text-white mb-6">
              Ordina Online
            </h1>
            <p className="text-lg md:text-2xl font-body text-white max-w-3xl mx-auto">
              Scopri il mio menu e ordina i tuoi piatti preferiti
            </p>
          </div>
        </div>
      </section>

      {/* Main CTA Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="mb-12">
            <h2 className="text-3xl md:text-5xl font-title font-bold text-sage-dark mb-6">
              Menu 
            </h2>
            <p className="text-xl font-body text-neutral-600 mb-4 leading-relaxed">
              Scopri il mio menu, personalizza i tuoi ordini e scegli se fartelo consegnare a casa o se ritirarlo presso la pasticceria "La Dolce Pausa" di Colzate. 
              Un'esperienza di ordinazione semplice e veloce per portare 
              gustosi piatti a casa tua.
            </p>
          </div>

          {/* Featured Image */}
          <div className="mb-12">
            <div 
              className="rounded-3xl shadow-2xl h-[28rem] w-80 bg-cover bg-center mx-auto"
              style={{
                backgroundImage: `url('/images/Still%202025-07-24%20182646_1.28.1%5B1%5D.jpg')`,
                backgroundPosition: '50% 20%'}}
            />
          </div>

          {/* Main CTA Button */}
          <div className="mb-12">
            <a 
              href="https://48ig4en6nuwn8uwrecno4owo7qy6lua4.pwa.pienissimo.pro/home?hashform=48ig4en6nuwn8uwrecno4owo7qy6lua4"
              className="inline-block bg-sage-dark hover:bg-sage-medium text-white px-12 py-6 rounded-full font-bold text-xl transition-all duration-300 transform hover:scale-105 shadow-xl hover:shadow-2xl"
              target="_blank"
              rel="noopener noreferrer"
            >
              🍽️ Vai al Menu 
            </a>
            <p className="text-sm font-body text-neutral-500 mt-4">
              *Si apre in una nuova finestra
            </p>
          </div>

          {/* Benefits */}
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="text-center">
              <div className="bg-sage-light rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-sage-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-title font-semibold text-sage-dark mb-2">Ordinazione Facile</h3>
              <p className="font-body text-neutral-600">
                Interfaccia intuitiva per ordinare in pochi click
              </p>
            </div>

            <div className="text-center">
              <div className="bg-sage-light rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-sage-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                </svg>
              </div>
              <h3 className="text-lg font-title font-semibold text-sage-dark mb-2">Pagamento Sicuro</h3>
              <p className="font-body text-neutral-600">
                Transazioni protette e diverse opzioni di pagamento
              </p>
            </div>

            <div className="text-center">
              <div className="bg-sage-light rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-sage-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-title font-semibold text-sage-dark mb-2">Consegna Programmata</h3>
              <p className="font-body text-neutral-600">
                Scegli quando ricevere i tuoi piatti preferiti
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-20 bg-beige-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-title font-bold text-sage-dark mb-6">
              Come Ordinare
            </h2>
            <p className="text-xl font-body text-neutral-600 max-w-3xl mx-auto">
              Tre semplici passaggi per portare Acquolina a casa tua
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Step 1 */}
            <div className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500">
              <div className="text-center">
                <div className="bg-sage-dark text-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
                  <span className="text-2xl font-bold">1</span>
                </div>
                <h3 className="text-2xl font-title font-bold text-sage-dark mb-4">
                  Consegna a domicilio o ritiro?
                </h3>
                <p className="font-body text-neutral-600 mb-6 min-h-[4rem]">
                  Scegli se farti consegnare a casa il tuo ordine oppure passare presso il punto di ritiro. Seleziona quindi la sezione ordini dedicata alla tua modalità preferita.
                </p>
                <div className="mb-4">
                  <div 
                    className="h-40 bg-cover bg-center rounded-lg"
                    style={{
                      backgroundImage: `url('/images/Immagine%20WhatsApp%202025-07-24%20ore%2023.22.47_ca878501.jpg')`,
                      backgroundPosition: '50% 92%'
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500">
              <div className="text-center">
                <div className="bg-sage-dark text-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
                  <span className="text-2xl font-bold">2</span>
                </div>
                <h3 className="text-2xl font-title font-bold text-sage-dark mb-4">
                  Esplora il Menu
                </h3>
                <p className="font-body text-neutral-600 mb-6 min-h-[4rem]">
                  Sfoglia il mio menu e scopri tutti 
                  i piatti disponibili con descrizioni dettagliate e ingredienti. Le prenotazioni saranno aperte dal giovedì al sabato per le consegne su inizio settimana.
                </p>
                <div className="mb-4">
                  <div 
                    className="h-40 bg-cover bg-center rounded-lg"
                    style={{
                      backgroundImage: `url('/images/gastronomia-mission.jpg')`,
                      backgroundPosition: '50% 35%'
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Step 3 */}
            <div className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500">
              <div className="text-center">
                <div className="bg-sage-dark text-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
                  <span className="text-2xl font-bold">3</span>
                </div>
                <h3 className="text-2xl font-title font-bold text-sage-dark mb-4">
                  Paga e Ricevi
                </h3>
                <p className="font-body text-neutral-600 mb-6 min-h-[4rem]">
                  Completa l'ordine con i tuoi dati, se scegli di ritirarlo presso la pasticceria 
                  "La Dolce Pausa" dovrai effettuare un pagamento anticipato, mentre per la consegna 
                  a domicilio potrai utilizzare il metodo che preferisci.
                </p>
                <div className="mb-4">
                  <div 
                    className="h-40 bg-cover bg-center rounded-lg"
                    style={{
                      backgroundImage: `url('/images/pexels-mikhail-nilov-6969962.jpg')`,
                      backgroundPosition: '50% 50%'
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-title font-bold text-sage-dark mb-6">
              Domande Frequenti
            </h2>
            <p className="text-xl font-body text-neutral-600">
              Tutto quello che devi sapere per ordinare
            </p>
          </div>

          <div className="space-y-6">
            <div className="bg-beige-light rounded-3xl p-6">
              <h3 className="text-xl font-title font-semibold text-sage-dark mb-3">
                Quali sono i tempi di consegna?
              </h3>
              <p className="font-body text-neutral-600">
                Offro consegne settimanali programmate. Puoi selezionare 
                il giorno e l'orario di consegna che preferisci tra le disponibilità presenti in fase di ordinazione.
              </p>
            </div>

            <div className="bg-beige-light rounded-3xl p-6">
              <h3 className="text-xl font-title font-semibold text-sage-dark mb-3">
                Come funziona la conservazione ATM?
              </h3>
              <p className="font-body text-neutral-600">
                I miei piatti sono confezionati in atmosfera modificata, 
                una tecnologia che mantiene freschezza e qualità per diversi giorni, 
                preservando sapori e proprietà nutritive. Sarai tu a valutare se preferisci congelarli a casa tua.
              </p>
            </div>

            <div className="bg-beige-light rounded-3xl p-6">
              <h3 className="text-xl font-title font-semibold text-sage-dark mb-3">
                Posso personalizzare i piatti?
              </h3>
              <p className="font-body text-neutral-600">
                No, i piatti presenti in menù sono pensati per soddisfare il più possibile le diverse esigenze e preferenze. 
              </p>
            </div>
            <div className="bg-beige-light rounded-3xl p-6">
              <h3 className="text-xl font-title font-semibold text-sage-dark mb-3">
                I piatti che non contengono glutine negli ingredienti sono certificati?
              </h3>
              <p className="font-body text-neutral-600">
                No, possono essere presenti delle contaminazioni non essendo un laboratorio di produzione dedicato al senza glutine.
              </p>
            </div>

            <div className="bg-beige-light rounded-3xl p-6">
              <h3 className="text-xl font-title font-semibold text-sage-dark mb-3">
                Quali metodi di pagamento sono accettati?
              </h3>
              <p className="font-body text-neutral-600">
                Per il ritiro, presso la pasticceria "La Dolce Pausa", è necessario pagare con Paypal e Satispay in fase di ordinazione online .
                Per la consegna a domicilio sono disponibili sia il pagamento in contanti che tramite carta, anche direttamente alla consegna.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Alternative Contact */}
      <section className="py-20 bg-sage-dark text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-5xl font-title font-bold mb-6">
            Hai Bisogno di Aiuto?
          </h2>
          <p className="text-xl font-body mb-8 opacity-90">
            Non riesci a ordinare online? Contattami direttamente e ti guiderò per
            completare il tuo ordine.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://wa.me/393458279163?text=Ciao, ho visto il tuo sito ACQUOLINA e vorrei maggiori informazioni sui tuoi servizi."
              className="bg-white text-sage-dark hover:bg-beige-light px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105"
              target="_blank"
              rel="noopener noreferrer"
            >
              Scrivimi su WhatsApp
            </a>
            <a 
              href="tel:+39XXX-XXX-XXXX"
              className="border-2 border-white hover:bg-white hover:text-sage-dark px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105"
            >
              Chiama Ora
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Ordina;